import * as firebase from 'firebase';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBfC9rTiZdI3uRHFkhSWvUDHATxwLxwBzE",
    authDomain: "forever-story.firebaseapp.com",
    databaseURL: "https://forever-story.firebaseio.com",
    projectId: "forever-story",
    storageBucket: "forever-story.appspot.com",
    messagingSenderId: "713193350716"
});

const auth = firebaseApp.auth();
const db = firebaseApp.firestore();

export { db, auth };


// WEBPACK FOOTER //
// ./src/util/firebase.js